<div class="container {{themeService?.isDarkMode ? 'dark' : 'light'}} {{summaryView ? 'summary-view' : ''}}">
  {{ pointScore || 0 }}
</div>
